var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media-course"},[(_vm.initLoad)?_c('div',[(_vm.courseDetail.mediaLevel == 1)?_c('FirstCourse',{attrs:{"courseData":_vm.courseDetail,"onclick":_vm.handleCourseItem}}):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }